import React, { useLayoutEffect, useEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import TransitionLink from 'gatsby-plugin-transition-link'
import { gsap } from "gsap";
import VisibilitySensor from 'react-visibility-sensor'
import ReactPlayer from 'react-player'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import PjmGlance from "../components/pjm-glance"
import useWindowSize from "../hooks/useWindowDimensions"
import VideoSrc from "../videos/Offshore Wind Illustration_Edit.mp4"
import VideoSrcMobile from "../videos/Sprint3_Planning_OffshoreWind.mp4"
import nextImage from "../images/Hero_06_RiskManagement.jpg"
import prevImage from "../images/Hero_05_Reliability_Resilience.jpg"
import nextRings from "../images/RINGS_BLUE_YELLOW.svg"
import prevRings from "../images/RINGS_BLUE_MAGENTA.svg"
import chevronDown from "../images/angle-down.svg"
import arrowLeft from "../images/yellow-arrow.svg"
import "../components/pages.scss"
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { Link } from "gatsby"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"



gsap.registerPlugin(ScrollTrigger);
ChartJS.register(ArcElement, Tooltip, Legend);

const PlanningPage = (props) => {
    const size = useWindowSize();
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();
    const [desktopViewState, setDesktopViewState] = useState(null);
    // const [data, setData] = useState();
    const dChart = useRef();

    useLayoutEffect(() => {
        console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(firstRow.current, { y: 200, ease: "power2"});
        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    const [data, setData] = useState({
      labels: ['Solar', 'Storage', 'Wind', 'Hybrid Resources', 'Natural Gas', 'Other Fuels'],
      datasets: [
        {
          label: 'CURRENT INTERCONNECTION QUEUE',
          data: [0,0,0,0,0,0],
          backgroundColor: [
            '#F4C22A',
            '#5091CD',
            '#EC9649',
            '#8EBC41',
            '#6EC2E1',
            '#E41087',
          ],
          borderColor: [
            '#FFFFFF',
            '#FFFFFF',
            '#FFFFFF',
            '#FFFFFF',
            '#FFFFFF',
            '#FFFFFF',
          ],
          borderWidth: 2,
        },
      ],
    });

    const options = {
        layout: { padding: 10 },
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
            position: 'right'
          }
        }
      };
    const plugins = [];

    const [playVideo, setPlayVideo] = useState(true);
    function onChangeVideo(isVisible) {
        if(false) {
            setPlayVideo(true);
        }
    }
    const [videoUrl, setVideoUrl] = useState(VideoSrc);
    // useEffect(() => {
    //     const mql = window.matchMedia('(min-width: 64rem)');
    //     setDesktopViewState(mql.matches);

    //     if(desktopViewState) {
    //         setVideoUrl(VideoSrc);
    //     } else {
    //         setVideoUrl(VideoSrcMobile);
    //     }
    // }, [size, desktopViewState]);

    function onChangeChart(isVisible) {
        console.log(isVisible, 'vis');
        if(isVisible) {
            setData((prevState) => ({
                ...prevState,
                datasets: [
                  {
                    data: [107282, 37821, 37607, 31948, 9774, 1400],
                    backgroundColor: [
                      '#F4C22A',
                      '#5091CD',
                      '#EC9649',
                      '#8EBC41',
                      '#6EC2E1',
                      '#E41087',
                    ],
                    borderColor: [
                      '#FFFFFF',
                      '#FFFFFF',
                      '#FFFFFF',
                      '#FFFFFF',
                      '#FFFFFF',
                      '#FFFFFF',
                    ],
                    borderWidth: 2,
                  },
                ],
            }))
        }
    }

    useEffect(() => {
        dChart.current.clear();
    }, []);

    return (
        <Layout>
            <main className="page planning">
                <title>Planning Page</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 6 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="welcome" className="text--yellow">Planning</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile" data-scroll data-scroll-speed="0">
                                        <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_07_Planning.jpg" alt="" />
                                        <img className="rings" src={ringsby} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div data-scroll data-scroll-speed="3" className="title--super text--outline">ENVISIONING THE
                                    </div>
                                        <h1 data-scroll data-scroll-speed="2">FUTURE</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                            >
                                                Read Lorem
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" /> 
                                </div>
                                <div
                                    ref={(element) => circles.current[0] = element} 
                                    className="circle--blue top p-7"
                                    data-speed=".1"
                                ></div>
                                <div
                                    ref={(element) => circles.current[1] = element} 
                                    className="circle--green top p-7"
                                    data-speed=".3"
                                ></div>
                                <div
                                    ref={(element) => circles.current[2] = element} 
                                    className="circle--yellow top p-7"
                                   data-speed=".2"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                    <div className="col-xs-12">
                        <p className="text text--intro">Transitioning reliably and cost-effectively to a grid that will incorporate many more intermittent renewable resources was a main focus of planning efforts by PJM and its stakeholders in 2021.</p>
                        <p className="text text--intro">As of the end of 2021, 95% of the more than 225,000 MW in PJM’s new services queue were proposed solar, wind, storage or hybrid renewable/battery resources.</p>
                        <p className="text text--intro">As the independent planner for the future needs of our bulk electric system, PJM’s primary objective is maintaining reliability while transitioning to the grid of the future. This work is informed by our strategic direction and is supported by research, analytical studies and active collaboration with our stakeholders to try and ensure durable solutions.</p>
                        <h5 className="text--uppercase">Interconnection Process Reform</h5>
                        <p className="text">As the energy transition accelerates, PJM’s interconnection queue has grown significantly; the number of generation project requests that entered the interconnection queue in 2021 was 1,331, nearly triple the number just three years ago.</p>
                        <p className="text">To streamline planning for new queue requests, PJM and stakeholders worked together to improve the interconnection process. This collaborative and comprehensive work proceeded with the formation of the Interconnection Process Reform Task Force (IPRTF) and a series of workshops to study related policies, including cost-allocation methods. </p>
                        <p className="text">The broad goal of this collaboration was twofold:</p>
                        <ul>
                            <li>Advancing projects through the interconnection process more quickly</li>
                            <li>Enhancing cost certainty</li>
                        </ul>
                        <p className="text">By year’s end, the IPRTF remained on track to file proposed Open Access Transmission Tariff (Tariff) changes with FERC in the first half of 2022.</p>
                    </div>
                </div>
                <div className="sec-pad">
                    <div className="row row-wrapper content">
                        <div class="col-xs-12">
                            <h6 className="text--uppercase">Current Interconnection Queue</h6>
                        </div>
                        <div className="col-xs-12 col-md-5">
                            <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeChart}>
                                <Doughnut ref={dChart} data={data} options={options} plugins={plugins} />
                            </VisibilitySensor>
                        </div>
                        <div className="col-xs-12 col-md-3">
                            <div className="legend">
                                <div className="legend__item">
                                    <div className="legend__color yellow"></div>
                                    <div className="legend__title">Solar</div>
                                    <div className="legend__total">107,282 MW</div>
                                </div>
                                <div className="legend__item">
                                    <div className="legend__color blue"></div>
                                    <div className="legend__title">Storage</div>
                                    <div className="legend__total">37,821 MW</div>
                                </div>
                                <div className="legend__item">
                                    <div className="legend__color orange"></div>
                                    <div className="legend__title">Wind</div>
                                    <div className="legend__total">37,607 MW</div>
                                </div>
                                <div className="legend__item">
                                    <div className="legend__color green"></div>
                                    <div className="legend__title">Hybrid Resources</div>
                                    <div className="legend__total">31,948 MW</div>
                                </div>
                                <div className="legend__item">
                                    <div className="legend__color lightblue"></div>
                                    <div className="legend__title">Natural Gas</div>
                                    <div className="legend__total">9,774 MW</div>
                                </div>
                                <div className="legend__item">
                                    <div className="legend__color pink"></div>
                                    <div className="legend__title">Other Fuels</div>
                                    <div className="legend__total">1,400 MW</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4 rel">
                            <div className="overlap-bubbles">
                                <div className="bubble-green circle--green">
                                    <div className="info">
                                        <div className="bubble-text">
                                            PROPOSED GENERATION CAPABILITY
                                        </div>
                                        <div className="bubble-total">
                                            225,832 MW
                                        </div>
                                    </div>
                                </div>
                                <div className="bubble-blue circle--blue">
                                    <div className="info">
                                        <div className="bubble-text">
                                            PROJECTS UNDER STUDY
                                        </div>
                                        <div className="bubble-total">
                                            2,474
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    ref={(element) => circles.current[3] = element} 
                    className="circle--yellow page-1"
                   data-speed=".2"
                ></div>
                   <div className="quote-wrap bg-blue sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12">
                            <div className="p-t-40 p-b-40">
                                <div className="row row-wrapper content max--1024">
                                    <div className="col-xs-12 text--center">
                                        <p className="text text--yellow text--large quote-text">“We’re in the middle of a major transformation across the entire system.”</p>
                                        <p className="text text--uppercase text--yellow text--large quote-name">Ken Seiler, Vice President – Planning</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">Regional Transmission Planning Focus</h5>
                        <p className="text">In July, FERC issued an Advance Notice of Proposed Rulemaking (ANOPR), titled “Building for the Future Through Electric Regional Transmission Planning and Cost Allocation and Generator Interconnection.”</p>
                        <p className="text">This FERC initiative provided an opportunity for PJM to share four principles it believes should guide any planning reform:</p>
                        <ul>
                            <li>Decarbonization policy facilitation</li>
                            <li>Grid resilience</li>
                            <li>Consumer protection</li>
                            <li>Equitable treatment of regional transmission organization (RTO) and non-RTO regions</li>
                        </ul>
                        <p className="text">In 2021, FERC and state utility regulators also partnered to form the Joint Federal-State Task Force on Electric Transmission. This three-year initiative explores:</p>
                        <ul>
                            <li>The need to modernize and expand bulk electric system infrastructure to accommodate the changing resource mix</li>
                            <li>The barriers to transmission expansion and project siting at local, state and regional levels</li>
                            <li>The role of technology in expanding transmission capacity</li>
                        </ul>
                    </div>
                </div>
                <div className="row row-wrapper content">
                    <div className="col-xs-12">
                        <h5 className="text--uppercase">Preparing for Offshore Wind</h5>
                        <p className="text">All but three of the 13 states within PJM’s region are pursuing renewable generation objectives. Effective planning for the grid of the future includes PJM facilitation of states’ varying decarbonization goals.</p>
                        <p className="text">In 2021, FERC approved PJM’s first-time use of an existing provision in its governing documents, the State Agreement Approach, to assist New Jersey’s goal of constructing and integrating 7,500 MW of offshore wind generation by 2035.</p>
                        <p className="text">New Jersey is hardly alone among states pursuing offshore wind. Together, the five coastal states in PJM’s footprint have proposed developing more than 20,000&nbsp;MW of offshore wind resources.</p>
                        <p className="text">In October, PJM published the Phase 1 results of its Offshore Wind Transmission Study, a collaborative effort with state agencies to identify transmission solutions across the PJM footprint.</p>
                        <p className="text">The report found that coordinated regional transmission planning among states could present a more efficient, economic path to achieving these objectives in lieu of the status quo where each state is working alone.</p>
                    </div>
                </div>
                <div className="sec-pad">
                    <div className="row row-wrapper content">
                        <div className="col-xs-12">
                            <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeVideo}>
                                <div style={{position: 'relative'}}>
                                    <ReactPlayer 
                                        playing={playVideo}
                                        url={videoUrl} 
                                        width='100%'
                                        height='100%'
                                        className='react-player'
                                        muted
                                        playsinline
                                        loop
                                    />
                                </div>
                            </VisibilitySensor>
                        </div>
                    </div>
                </div>
            </main>
            <Footer 
                nextLink="/risk-management" 
                nextImage={nextImage}
                nextText="Next &gt;"
                nextTitle="Risk Management"
                nextButton="" 
                nextRings={nextRings} 
                prevLink="/reliability" 
                prevImage={prevImage}
                prevText="&lt; Previous"
                prevButton=""
                prevTitle="Reliability & Resilience"  
                prevRings={prevRings} 
            />
        </Layout>
    )
}

export default PlanningPage
